<template>
  <div :class="[{'fy-form-inline':inline}]" class="fy-form-div">
    <form class="fy-form">
      <slot></slot>
    </form>
  </div>
</template>
<script>
import AsyncValidator from 'async-validator'
export default {
  name: 'fy-form',
  componentName: 'FyForm', // 通过 $options.componentName 来取
  provide () {
    return {
      fyForm: this
    }
  },
  props: {
    model: Object,
    rules: Object,

    /**
     * 表示form中的所有formItem都是行内元素
     * 注意：
        1.行内显示时config.js中的errorType设置为1(即消息提示悬浮在输入框上方)
        2.formItem中有label的时候建议指定width和inner_width的值
     * 使用例子：
        <fy-form :inline="true" :model="form" style="text-align: left">
            <fy-form-item label="页面英文名称" :width="'25%'" :inner_width="'60%'">
                <fy-input type="text" v-model="form.pageEnname" placeholder="page_enname"></fy-input>
            </fy-form-item>
            <fy-form-item label="语言" :width="'12%'" :inner_width="'60%'">
                <fy-select v-model="locale" :options="languages" labelKey="key_name" valueKey="key_value"></fy-select>
            </fy-form-item>
            <el-button type="primary" @click="onSubmit(true)">查询</el-button>
        </fy-form>
     */
    inline: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      fields: [], // form下的所有formitem组件
      formError: {}
    }
  },
  created () {
    // 注册添加formitem事件
    this.$on('form.addField', field => {
      if (field) {
        this.fields.push(field)
      }
    })
    /* 注册销毁formitem事件 */
    this.$on('form.removeField', field => {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    })
  },
  watch: {
    rules (value) {
      console.log(value)
    }
  },
  computed: {
    // formRules() {
    //     const descriptor = {}
    //     this.fields.forEach(({ prop }) => {
    //         if (!Array.isArray(this.rules[prop])) {
    //             console.warn(
    //                 `prop 为 ${prop} 的 FormItem 校验规则不存在或者其值不是数组`
    //             )
    //             descriptor[prop] = [{ required: true }]
    //             return
    //         }
    //         descriptor[prop] = this.rules[prop]
    //     })
    //     return descriptor
    // },
    formValues () {
      const formData = this.fields.reduce((data, { prop }) => {
        data[prop] = this.model[prop]
        return data
      }, {})
      return formData
    }
  },
  methods: {
    /**
     * return:
     * array Fields ：数据验证失败的fields
     * boolean valid : 验证成功返回true
     */
    validate (callback) {
      const validator = new AsyncValidator(this.rules)
      if (!this.model) {
        console.warn(
          '[Element Warn][Form]model is required for validate to work!'
        )
        return
      }
      // let promise;
      // // if no callback, return promise
      // if (typeof callback !== "function" && window.Promise) {
      //   promise = new window.Promise((resolve, reject) => {
      //     callback = function(valid) {
      //       valid ? resolve(valid) : reject(valid);
      //     };
      //   });
      // }
      let valid = true
      let count = 0
      // 如果需要验证的fields为空，调用验证时立刻返回callback
      if (this.fields.length === 0 && callback) {
        callback(true)
      }

      let invalidFields = []
      //调用formitem的验证
      this.fields.forEach(field => {
        field.validate('', true, (message, fieldItem) => {
          if (message) {
            valid = false
            var item = {}
            item.message = message
            item.prop = field.prop
            invalidFields.push(item)
          }
          if (
            typeof callback === 'function' &&
            ++count === this.fields.length
          ) {
            callback(valid, invalidFields)
          }
        })
      })
      // if (promise) {
      //   return promise;
      // }
      return { valid: valid, Fields: invalidFields }
    },
    /**
     * 通过prop验证单个form-item
     * callback为回调函数
     */
    validateField (prop, callback) {
      let field = this.fields.filter(field => field.prop === prop)[0]
      if (!field) {
        throw new Error(prop + '对应的form-item不存在')
      }
      field.validate('', true, callback)
    },
    validateFields (props, callback) {
      let valid = true
      let count = 0
      let invalidFields = []
      for (var index in props) {
        let field = this.fields.filter(field => field.prop === props[index])[0]
        if (!field) {
          throw new Error(props[index] + '对应的form-item不存在')
        }
        //调用formitem的验证
        field.validate('', true, (message, fieldItem) => {
          if (message) {
            valid = false
            var item = {}
            item.message = message
            item.prop = field.prop
            invalidFields.push(item)
          }
          if (
            typeof callback === 'function' &&
            ++count === props.length
          ) {
            callback(valid, invalidFields)
          }
        })
      }
      return { valid: valid, Fields: invalidFields }
    },
    resetFields () {
      if (!this.model) {
        console.log('prop:model不能为空')
        return
      } else {
        this.fields.forEach(field => {
          field.resetField()
        })
      }
    }
  }
}
</script>
<style scoped>
@import '../../assets/css/components/form/form.css';
</style>




// WEBPACK FOOTER //
// src/components/form/form.vue